import styled from "styled-components";

export const EmployeeDashboardWrapper = styled("div")(() => {
  return {
    borderRadius: "1rem",
    backgroundColor: "var(--color-background)",
    overflow: "hidden",
    "& .title-heading": {
      padding: "1.25rem 0",
      margin: "1rem 0",
      gap: "1rem",
      display: "flex",
      flexDirection: "column",
      "& h1": {
        marginBlock: 0,
      },
      "& h2": {
        marginBlock: 0,
      },
    },
    "& .filter": {
      border: "1px solid #e5e7eb",
      borderRadius: "0.85rem",
      backgroundColor: "var(--color-primary-hover)",
      padding: "1rem",
      margin: " 1.25rem 0",
      display: "grid",
      gap: "1rem",
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
      alignItems: "end",
    },
    "& .filter select, & .filter input": {
      padding: "calc(var(--cardPadding) / 3) calc(var(--cardPadding) / 2)",
      borderRadius: "0.45rem",
      border: "1px solid #d9dee7",
      fontWeight: "400",
      color: "var(--color-text)",
      backgroundColor: "var(--color-neutral)",
      "&:focus": {
        outline: "none",
        border: "none",
      },
    },
    "& .filter fieldset": {
      flex: 1,
      overflow: "hidden",
    },
    "& .filter label": {
      fontFamily: "Poppins",
      fontWeight: 600,
      fontSize: "0.8rem",
      color: "var(--color-primary)",
      textTransform: "uppercase",
      letterSpacing: "0.05em",
      marginBottom: "0.45rem",
      display: "inline-block",
    },

    "& .table": {
      border: "1px solid #e5e7eb",
      borderRadius: "0.9rem",
      overflow: "auto",
      backgroundColor: "var(--color-neutral)",
      margin: "1.25rem 0",
    },
    "& table": {
      width: "100%",
      borderCollapse: "separate",
      borderSpacing: 0,
      minWidth: "540px",
    },
    "& table th": {
      backgroundColor: "var(--color-primary-hover)",
      color: "var(--color-primary)",
      borderBottom: "1px solid #e5e7eb",
      borderTop: "none",
      borderLeft: "none",
      borderRight: "none",
      padding: "0.8rem 1rem",
      textTransform: "uppercase",
      letterSpacing: "0.04em",
      fontSize: "0.8rem",
      minWidth: "unset",
      fontWeight: 700,
      textAlign: "left",
    },
    "& table td": {
      border: "none",
      borderBottom: "1px solid #edf1f6",
      color: "var(--color-text)",
      padding: "0.95rem 1rem",
      minWidth: "unset",
      fontSize: "0.88rem",
      verticalAlign: "middle",
    },
    "& table tbody tr:last-child td": {
      borderBottom: "none",
    },

    "& table tbody tr td:last-child": {
      cursor: "pointer",
      transition: "text-decoration 0.2s ease",
      color: "var(--color-primary)",
    },
    "& table tbody tr td:last-child:hover": {
      textDecoration: "underline",
    },

    "& .table-footer": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "0.8rem 1rem",
      gap: "0.8rem",
      flexWrap: "wrap",
      color: "var(--color-text-light)",
      fontFamily: "Poppins",
      fontSize: "0.8rem",
    },
    "& .pagination": {
      display: "inline-flex",
      gap: "0.45rem",
      alignItems: "center",
    },
    "& .page-chip": {
      appearance: "none",
      width: "1.7rem",
      height: "1.7rem",
      border: "1px solid #d9dee7",
      borderRadius: "0.35rem",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      color: "var(--color-text-light)",
      fontWeight: 600,
      backgroundColor: "var(--color-neutral)",
      cursor: "pointer",
      padding: 0,
    },
    "& .page-chip.active": {
      backgroundColor: "var(--color-primary)",
      color: "#ffffff",
      borderColor: "var(--color-primary)",
    },
    "& .page-chip:disabled": {
      opacity: 0.45,
      cursor: "not-allowed",
    },
    "& .reset-password-modal": {
      padding: "1.25rem",
      background: "#FFFFFF",
      position: "fixed",
      top: "50%",
      left: "50%",
      height: "auto",
      transform: "translate(-50%, -50%)",
      borderRadius: "1rem",
      boxShadow: "0px 4px 4px 4px rgba(0, 0, 0, 0.25)",
      "@media screen and (max-width: 425px)": {
        width: "85%",
        padding: "var(--cardPadding) calc(var(--cardPadding)/2)",
      },
    },
    "& .payslip-details-modal": {
      position: "fixed",
      top: "50%",
      left: "50%",
      height: "auto",
      transform: "translate(-50%, -50%)",
      backgroundColor: "#FFFFFF",
      borderRadius: "1rem",
      boxShadow: "0px 4px 4px 4px rgba(0, 0, 0, 0.25)",
      "@media screen and (max-width: 768px)": {
        bottom: "0",
        right: "0",
        top: "50%",
        height: "75%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: "#FFFFFF",
        borderRadius: "1rem",
      },
      "@media screen and (max-width: 425px)": {
        width: "85%",
        padding: "var(--cardPadding) calc(var(--cardPadding)/2)",
      },
    },
    "@media screen and (max-width: 768px)": {
      borderRadius: "0.75rem",
      "& .filters-card": {
        padding: "0.75rem 1rem",
        margin: "-0.1rem 1rem 1rem",
      },
      "& .filters-grid": {
        gridTemplateColumns: "1fr",
      },
      "& .table-card": {
        margin: "0 1rem 1rem",
      },
    },
  };
});
